/* ================================================================
   PRODUCT CARD IMAGE CAROUSEL — card-carousel.js
   Added: September 2026
   ================================================================ */

(function () {
  const INTERVAL = 4000;
  const initialized = new WeakSet();

  function initCarousel(cardMedia) {
    if (initialized.has(cardMedia)) return;
    const mediaDiv = cardMedia.querySelector('.media');
    if (!mediaDiv) return;
    const imgs = Array.from(mediaDiv.querySelectorAll('img'));
    if (imgs.length < 2) return;
    initialized.add(cardMedia);

    mediaDiv.classList.remove('media--hover-effect');
    mediaDiv.style.overflow = 'hidden';
    mediaDiv.style.position = 'relative';

    // Crossfade setup
    imgs.forEach((img, i) => {
      img.style.position = 'absolute';
      img.style.top = '0';
      img.style.left = '0';
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.objectFit = 'cover';
      img.style.display = 'block';
      img.style.transition = 'opacity 1500ms ease';
      img.style.opacity = i === 0 ? '1' : '0';
    });

    let cur = 0;
    let timer = setInterval(next, INTERVAL);

    function next() {
      imgs[cur].style.opacity = '0';
      cur = (cur + 1) % imgs.length;
      imgs[cur].style.opacity = '1';
    }

    const cardWrapper = cardMedia.closest('.card-wrapper') || cardMedia;

    cardWrapper.addEventListener('mouseenter', () => clearInterval(timer));
    cardWrapper.addEventListener('mouseleave', () => { timer = setInterval(next, INTERVAL); });

    if (cardWrapper !== cardMedia) {
      const productLink = cardWrapper.querySelector('a.full-unstyled-link');
      const infoBlock = cardWrapper.querySelector('.card-information');
      if (infoBlock && productLink) {
        infoBlock.addEventListener('click', () => { window.location.href = productLink.href; });
      }
    }
  }

  function tryInit() {
    document.querySelectorAll('.card__media[data-carousel="true"]').forEach(initCarousel);
  }

  window.addEventListener('load', tryInit);
  setTimeout(tryInit, 1000);
  setTimeout(tryInit, 3000);

})();
